import { FC, PropsWithChildren, ReactElement, Ref, cloneElement, useEffect, useRef } from "react";

type LineMetrics = {
  lines: number;
  height: number;
  lineHeight: number;
};

interface LineCounterProps {
  children: ReactElement<{ ref?: Ref<HTMLElement> }>;
  callback: (metrics: LineMetrics) => void;
}

const LineCounter: FC<LineCounterProps> = ({ children, callback }) => {
  const textRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const height = rect.height;

    const computed = window.getComputedStyle(element);
    const lineHeightStr = computed.lineHeight;

    let lineHeight = parseFloat(lineHeightStr);

    if (!Number.isFinite(lineHeight)) {
      const fontSize = parseFloat(computed.fontSize) || 0;
      lineHeight = fontSize * 1.2;
    }

    const lines =
      lineHeight > 0 ? Math.max(1, Math.round(height / lineHeight)) : 0;

    callback({
      lines,
      height,
      lineHeight,
    });
  }, [callback]);

  return cloneElement(children, { ref: textRef });
};

export default LineCounter;import { FC, PropsWithChildren, ReactElement, Ref, cloneElement, useEffect, useRef } from "react";

type LineMetrics = {
  lines: number;
  height: number;
  lineHeight: number;
};

interface LineCounterProps {
  children: ReactElement<{ ref?: Ref<HTMLElement> }>;
  callback: (metrics: LineMetrics) => void;
}

const LineCounter: FC<LineCounterProps> = ({ children, callback }) => {
  const textRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const height = rect.height;

    const computed = window.getComputedStyle(element);
    const lineHeightStr = computed.lineHeight;

    let lineHeight = parseFloat(lineHeightStr);

    if (!Number.isFinite(lineHeight)) {
      const fontSize = parseFloat(computed.fontSize) || 0;
      lineHeight = fontSize * 1.2;
    }

    const lines =
      lineHeight > 0 ? Math.max(1, Math.round(height / lineHeight)) : 0;

    callback({
      lines,
      height,
      lineHeight,
    });
  }, [callback]);

  return cloneElement(children, { ref: textRef });
};

export default LineCounter;